import React, { createContext, FC, ReactNode, useContext } from 'react';

import { TablesStore } from '../../stores/TablesStore';

const TablesStoreContext = createContext<TablesStore>(new TablesStore());

const TablesStoreProvider: FC<{ store: TablesStore; children: ReactNode }> = ({
	store,
	children
}) => {
	return <TablesStoreContext.Provider value={store}>{children}</TablesStoreContext.Provider>;
};

const useTablesStore = (): TablesStore => {
	return useContext(TablesStoreContext);
};

export { TablesStoreProvider, useTablesStore };
